<template>
	<div class="feedback">
		<div class="feedback-content">
			<h3>问题反馈</h3>
			<p>请填写您的意见或建议，以便帮助我们更好的为您提供服务！</p>
		</div>
		<div class="footer clearfix">
			<div class="name-and-phone">
				<input type="text" placeholder="姓名" v-model="name"/>
				<input type="text" placeholder="手机号或邮箱"  v-model="mailbox"/>
				<span v-show="errorText">{{ errorText }}</span>
			</div>
			<textarea type="text" class="inpText" placeholder="咨询或建议" v-model="text" @focus="UpdateText(true)" @blur="UpdateText(false)"></textarea>
			<input type="button" value="提交" class="btn" @click="feedBack">
		</div>
		<Modal></Modal>
	</div>
</template>
<script>
	import Modal from '../common/MsgModal'
//	import axios from 'axios'
	export default {
		data () {
			return {
				text: '',
				name:"",
				mailbox:"",
				errorText:"",
				email:
				/^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
				mobile:
				/^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(14[0-9]{1}))+\d{8})$/,
			}
		},
		components:{Modal},
		mounted () {
      this.$store.commit('showHeader', false);
      this.$store.commit('setCurrentHeader', 'feedback');
		},
		methods: {
			checkMail(){
				if(this.mailbox == ''){
					this.$store.dispatch('showMsgModal',{
						autoClose:true,
						info:'手机号邮箱不能为空!'
					});
					// this.errorText="";
					return false
				}else{
					if(this.email.test(this.mailbox) || this.mobile.test(this.mailbox)){
						if(this.email.length >50){
							this.$store.dispatch('showMsgModal',{
								autoClose:true,
								info:'邮箱长度不能大于50位!'
							});
							// this.errorText="";
							return false
						}else{
							this.errorText="";
							return true;
						}
					}else{
						this.$store.dispatch('showMsgModal',{
								autoClose:true,
								info:'手机号邮箱格式错误!'
							});
						// this.errorText="";
						return false;
					}
				}
			},
			feedBack () {
				if(this.name == ''){
					this.$store.dispatch('showMsgModal',{
						autoClose:true,
						info:'姓名不可为空!'
					});
					return;
				}else{
					if(this.name.length <2 || this.name.length >30){
						this.$store.dispatch('showMsgModal',{
							autoClose:true,
							info:'姓名长度2-30个字!'
						});
						return;	
					}
				}
				if(!this.checkMail()){
					return
				}
				if(this.text == ''){
					this.$store.dispatch('showMsgModal',{
						autoClose:true,
						info:'咨询或建议不可为空'
					});
				}else if(this.text.length > 500){
					this.$store.dispatch('showMsgModal',{
						autoClose:true,
						info:'咨询或建议不可超过500字!'
					});
				}else if(this.text.length < 10){
					this.$store.dispatch('showMsgModal',{
						autoClose:true,
						info:'咨询或建议最少10个字!'
					});
				}else {
						// let user = this.$getLocalStorage('IP360', 'user');
						// let name = '';
						// if(user){
						// 	name = user.loginName;
						// }
						this.$axios.get('/webapi/addOpinion',{
							params: {
								// name: name == '' ? '' : name,
								name:this.name,
								mailbox:this.mailbox,
								opinion: this.text,
								sourceChanne: 4,
							}
						})
						.then((res)=>{
							if( res.data.code == '200' || res.data.code == '4002'){
								this.$router.push('/feedback/success');
							}else {
								this.$store.dispatch('showMsgModal',{
								autoClose:false,
								info:res.data.message
								});
							}
						})
						.catch((error)=>{
							console.log(error);
						})
				}
			},
			UpdateText (bool) {
				if( bool ){
					if( this.text == '' ){
						this.text = '';
					}
				}else {
					 if( this.text == '' ){
						this.text = '';
					}
				}
			}
		},
    destroyed () {
      this.$store.commit('showHeader', true);
    }
	}
</script>
<style>
body,html,h3,ul,li{
	margin:0;
	padding:0;
}
li{
	list-style: none;
}
.clearfix:after{
	content:".";
	display:block;
	height:0;
	clear:both;
	visibility:hidden
}
.feedback-content{
	border:none;
}
.clearfix{
	*+height:1%;
}
.feedback{
	width:1200px;
	height: 500px;
	text-align: center;
	margin:0 auto;
  margin-top:90px;
}
.feedback-content > h3{
	color:#b71d2a;
}
.feedback-content > p{
	color:#ccc;
}
.footer{
	width:700px;
	margin:0 auto;
}
.inpText{
	border:solid 1px #ccc;
	width:600px;
	height:200px;
	padding:20px;
	resize:none;
	margin-top:20px;
}
.feedback .btn{
	width:500px;
	background-color:#b71d2a;
	color:#fff;
	border:none;
	height:50px;
	border-radius: 5px;
	margin-top:70px;
	font-size:20px;
}
.name-and-phone{
	margin-top: 30px;
	position: relative;
}
.name-and-phone input{
	width: 290px;
    height: 40px;
    font-size: 14px;
    padding-left: 15px;
	border-radius: 3px;
	border: solid 1px #ccc;
}
.name-and-phone input:nth-child(2){
	margin-left: 15px;
}
.name-and-phone span{
	position: absolute;
	right: -100px;
	top: 10px;
	color: #b71d2a;
}
</style>



// WEBPACK FOOTER //
// FeedBack.vue?08335510